import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { contractConstants, contractModels } from '..';

export const useBdmConfig = () =>
  useQuery<contractModels.IBdmConfig>({
    queryKey: [contractConstants.queryKeys.BDM_CONFIG],
    queryFn: async () => {
      const res = await $api.get('/v1/bdm/config');

      return res?.data?.data;
    }
  });
